import "./styles.css";
import "react-photo-view/dist/react-photo-view.css";

import {
  ArrowLeftOutlined,
  LeftOutlined,
  MailOutlined,
  PhoneOutlined,
  RightOutlined,
  UserOutlined,
} from "@ant-design/icons";
import { Col, Row } from "antd";
import { Carousel, Image, Modal, Typography } from "antd";
import { useParams } from "react-router-dom";
import { PhotoProvider, PhotoView } from "react-photo-view";
import React, { useEffect, useState } from "react";
import { formatPrice, getPropertyType } from "./helpers";

import { Chip, useMediaQuery } from "@mui/material";
import { ContactForm } from "../components/ContactForm";
import { Helmet } from "react-helmet";
import { MapPin } from "lucide-react";
import axios from "axios";
import { API_URL } from "../config/api";
import { ExpandableText } from "../components/ExpendableText";
import agentPhoto from "../zoltan-photo.png";

const returnNormalUrl = (url: string) => {
  const parts = url.split("/optimized");
  return parts[0] + parts[1];
};

const { Title } = Typography;

export const ListingPage: React.FC = () => {
  const id = useParams<{ "*": string }>()["*"];

  const [listing, setListing] = useState<any>(undefined);
  const [shouldUpdate, setShouldUpdate] = useState(true);

  useEffect(() => {
    if (shouldUpdate) {
      axios.get(`${API_URL}/listings/${id}`).then((res) => {
        setListing(res.data);
        // console.log("the res data is", res.data);
      });
      setShouldUpdate(false);
    }
  }, [shouldUpdate, id]);

  const contentStyle: React.CSSProperties = {
    margin: 0,
    height: "10px", // adjust to your layout
    width: "100%",
    justifyContent: "center",
    alignItems: "center",
    borderRadius: "1.5rem",
  };

  const [previewVisible, setPreviewVisible] = useState(false);
  const [previewImage, setPreviewImage] = useState("");

  // const handlePreview = (imageUrl: string) => {
  //   setPreviewImage(imageUrl);
  //   setPreviewVisible(true);
  // };

  const handleCancel = () => {
    setPreviewVisible(false);
    setPreviewImage("");
  };

  //   const [form] = Form.useForm();

  //   const onFinish = (values: any) => {
  //     console.log("Submitted:", values);
  //     // Handle form submission (e.g., API call)
  //   };
  const isMobile = useMediaQuery("(max-width: 768px)");

  const previewImages = listing?.previewImages
    ? listing?.previewImages
    : listing?.photos ?? [];

  return (
    <React.Fragment>
      <Helmet>
        <title>{listing?.title}</title>
        <meta property="og:title" content={listing?.title} />
        <meta property="og:description" content={listing?.description} />
        <meta property="og:image" content={listing?.photos[0]} />
        <meta property="og:type" content="website" />
        <meta
          property="og:URL"
          content={"https://realityaandt.com/properties/" + id}
        />
      </Helmet>
      <Row style={{ padding: "1rem" }} gutter={[10, 10]}>
        <Col xs={24}>
          <a href="/properties" className="backButton">
            <ArrowLeftOutlined /> Späť na všetky inzeráty
          </a>
        </Col>
        {/* <Col xs={24} md={0} style={{ margin: 0, padding: 0 }}>
          {" "}
          <Title level={2} style={{ margin: 0, padding: 0 }}>
            1312{listing?.title}
          </Title>
        </Col> */}

        <Col xs={24} md={12}>
          <div
            style={{
              width: "100%",
            }}
          >
            <Carousel
              autoplay
              arrows={true}
              dots
              autoplaySpeed={1500}
              nextArrow={<LeftOutlined color="red" style={{ zIndex: 1000 }} />}
              prevArrow={<RightOutlined color="red" style={{ zIndex: 1000 }} />}
            >
              {listing?.photos?.map((image: any, index: number) => (
                <div key={index} style={contentStyle}>
                  <Image
                    src={image}
                    style={{
                      width: isMobile ? "100%" : "50vw",
                      height: "30rem",
                      // borderRadius: '1.5rem',
                      objectFit: "cover",
                    }}
                    preview={true} // disable fullscreen preview if undesired
                  />
                </div>
              ))}
            </Carousel>
            <Row gutter={[10, 10]} style={{ marginTop: "0.5rem" }}>
              <PhotoProvider>
                {
                  // <PhotoView src="/1.jpg">
                  //     <img src="/1-thumbnail.jpg" alt="" />
                  // </PhotoView>
                  // @ts-ignore
                  previewImages.map((photo, index) => (
                    <Col key={index} span={6}>
                      <PhotoView
                        src={
                          listing.hasPreviews ? returnNormalUrl(photo) : photo
                        }
                      >
                        <img
                          src={photo}
                          alt={`Property ${index}`}
                          style={{
                            width: "100%",
                            height: isMobile ? "5rem" : "10rem",

                            cursor: "pointer",
                            borderRadius: "5px",
                            objectFit: "cover",
                          }}
                          // onClick={() => handlePreview(photo)}
                        />
                      </PhotoView>
                    </Col>
                  ))
                }
              </PhotoProvider>
            </Row>
            <Modal
              visible={previewVisible}
              footer={null}
              onCancel={handleCancel}
            >
              <img
                alt="Preview"
                style={{ width: "100%", borderRadius: "0.5rem" }}
                src={previewImage}
              />
            </Modal>
          </div>
        </Col>
        <Col xs={24} md={12}>
          {/* <Col xs={0} md={24}>  <Title level={2}>{listing?.title}</Title></Col> */}

          <Row gutter={[32, 32]} style={{}}>
            {/* <Title level={2}>Popis nehnuteľnosti</Title> */}

            <div className="max-w-2xl mx-auto p-6 pt-0 font-sans">
              <h1 className="text-3xl font-extrabold uppercase leading-tight mb-2">
                {listing?.title}
              </h1>

              <div className="flex items-center gap-2 text-gray-600 mb-4">
                <MapPin size={18} />
                <span>
                  {listing?.location?.city}{" "}
                  {listing?.location?.country
                    ? ", " + listing?.location?.country
                    : ""}
                </span>
              </div>

              <div className="flex gap-2 mb-4">
                <Chip
                  key={"propertyType"}
                  className="border px-2 py-1 rounded-full"
                  label={getPropertyType(listing?.propertyType)}
                  style={{ marginRight: "0.5rem" }}
                  onClick={() =>
                    console.log("tag", getPropertyType(listing?.propertyType))
                  }
                />
                <Chip
                  key={"floorArea"}
                  className="border px-2 py-1 rounded-full"
                  label={listing?.floorArea + " m²"}
                  style={{ marginRight: "0.5rem" }}
                  onClick={() => console.log("tag", listing?.floorArea)}
                />
              </div>

              <div className="text-3xl font-semibold text-yellow-700 mb-4">
                {formatPrice(listing?.price)}
              </div>

              <div className="divide-y border rounded mb-6">
                <div
                  className="grid grid-cols-2 p-3 font-medium bg-gray-50"
                  style={{ backgroundColor: "#D9D9D9" }}
                >
                  <span>Typ nehnuteľnosti</span>
                  <span className="text-right">
                    {getPropertyType(listing?.propertyType)}
                  </span>
                </div>
                <div
                  className="grid grid-cols-2 p-3"
                  style={{ backgroundColor: "#f5f5f5" }}
                >
                  <span>Izby</span>
                  <span className="text-right">{listing?.rooms}</span>
                </div>
                <div
                  className="grid grid-cols-2 p-3"
                  style={{ backgroundColor: "#D9D9D9" }}
                >
                  <span>Kúpeľne</span>
                  <span className="text-right">{listing?.bathrooms}</span>
                </div>
                <div
                  className="grid grid-cols-2 p-3"
                  style={{ backgroundColor: "#f5f5f5" }}
                >
                  <span>Úžitková plocha</span>
                  <span className="text-right">{listing?.floorArea} m²</span>
                </div>
                <div
                  className="grid grid-cols-2 p-3"
                  style={{ backgroundColor: "#D9D9D9" }}
                >
                  <span>Celková plocha</span>
                  <span className="text-right">{listing?.wholeArea} m²</span>
                </div>
              </div>

              <div className="space-y-4 text-sm text-gray-800 leading-relaxed">
                {isMobile && (
                  <ExpandableText>
                    {listing?.description
                      ?.split("\n")
                      .map((line: any, index: number) => (
                        <p key={index}>{line}</p>
                      ))}
                  </ExpandableText>
                )}
                {!isMobile &&
                  listing?.description
                    ?.split("\n")
                    .map((line: any, index: number) => (
                      <p key={index}>{line}</p>
                    ))}
              </div>
            </div>

            {/* <List
                        // bordereds
                        dataSource={Object.keys(listing ?? {})}
                        style={{ width: "100%" }}
                        renderItem={(item) => {
                            if (["price", "rooms", "bathrooms", "floorArea", "wholeArea"].includes(item))
                                return (
                                    <List.Item>
                                        <Row style={{ width: "100%" }}>
                                            <Col span={12}>
                                                <span style={{ color: "silver", fontSize: item === "price" ? 32 : 16 }}>{translateAttributes(item)}</span>
                                            </Col>
                                            <Col span={12}>
                                                {<span style={{
                                                    color: item === "price" ? "gold" : "black", fontSize: item === "price" ? 32 : 16,
                                                    fontWeight: item === "price" ? "bold" : "inherit"
                                                }}>{listing[item]}</span>}
                                                <span style={{ color: item === "price" ? "gold" : "black", fontSize: item === "price" ? 32 : 16, fontWeight: item === "price" ? "bold" : "inherit" }}>{
                                                    item === "price" ? "€" : item === "floorArea" || item === "wholeArea" ? " m²" : ""
                                                }</span>
                                            </Col>
                                        </Row>
                                    </List.Item>
                                )
                            if (item === "propertyType") {
                                return (
                                    <List.Item>
                                        <Row style={{ width: "100%" }}>
                                            <Col span={12}>
                                                <span style={{ color: "silver", fontSize: 16 }}> {translateAttributes(item)}
                                                </span>
                                            </Col>
                                            <Col span={12}>
                                                <span style={{ color: "black" }}>{getPropertyType(listing[item])}</span>
                                            </Col>
                                        </Row>
                                    </List.Item>
                                )
                            }
                            return null
                        }
                        }
                    /> */}
            {/* <Text style={{ width: "100%" }}>{listing?.description}</Text>   <br /> */}

            {/* <Divider /> */}
            {/* 
                    <List
                        header={<div>Header</div>}
                        footer={<div>Footer</div>}
                        bordered
                        dataSource={Object.values(listing)}
                        renderItem={(item) => {
                            console.log("the item is", item);
                            if (typeof item !== "object")
                                return (
                                    <List.Item>
                                        <Typography.Text mark>[ITEM]</Typography.Text> {item}
                                    </List.Item>
                                )
                        }
                        }
                    /> */}
            {/* <Text strong style={{ width: "100%" }}>Price: ${listing?.price}</Text>   <br />

                    <Text strong>Location: {listing?.location?.address}, {listing?.location?.city}</Text>   <br />

                    <Text strong>Property Type: {listing?.propertyType}</Text>   <br />

                    <Text strong>Rooms: {listing?.rooms}</Text>   <br />

                    <Text strong>Bathrooms: {listing?.bathrooms}</Text>   <br />

                    <Text strong>Floor Area: {listing?.floorArea} m²</Text>   <br />

                    <Text strong>Whole Area: {listing?.wholeArea} m²</Text>   <br />

                    <Text strong>Listed Date: {new Date(listing?.listedDate).toLocaleDateString()}</Text>   <br /> */}

            {/* <Divider />
                <Text strong>Contact Information:</Text>   <br />

                <Text>Name: {listing?.contactInfo?.name}</Text>   <br />

                <Text>Phone: {listing?.contactInfo?.phone}</Text>   <br />

                <Text>Email: {listing?.contactInfo?.email}</Text>   <br /> */}
          </Row>
        </Col>
      </Row>

      <Row>
        <Col xs={24} md={12}>
          <div
            style={{
              border: "1px solid #f0c36d",
              borderRadius: "12px",
              boxShadow: "0 4px 8px rgba(0, 0, 0, 0.1)",
              padding: "1.5rem",
              margin: "1rem",
              marginTop: "0",
              fontSize: "26px",
              width: "90%",
              display: "flex",
              gap: "1.25rem",
            }}
          >
            {/* Profile picture */}
            <Image
              src={agentPhoto}
              style={{
                height: "22rem",
                objectFit: "cover",
                borderRadius: "1.5rem",
              }}
            />

            {/* Agent info */}
            <div style={{ lineHeight: 1.6 }}>
              <div
                style={{
                  fontWeight: 600,
                  fontSize: "20px",
                  marginBottom: "12px",
                }}
              >
                Váš realitný agent:
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "8px",
                  fontSize: "26px",
                  color: "gold",
                }}
              >
                <UserOutlined style={{ marginRight: 10, color: "gold" }} />
                <strong>Zoltán Dobos</strong>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  marginBottom: "8px",
                  fontSize: "26px",
                }}
              >
                <PhoneOutlined style={{ marginRight: 10, color: "gold" }} />
                <a href="tel:+421905738632" style={{ color: "inherit" }}>
                  +421 905 738 632
                </a>
              </div>

              <div
                style={{
                  display: "flex",
                  alignItems: "center",
                  fontSize: "26px",
                }}
              >
                <MailOutlined style={{ marginRight: 10, color: "gold" }} />
                <a
                  href="mailto:reality.zolka9@gmail.com"
                  style={{ color: "inherit" }}
                >
                  reality.zolka9@gmail.com
                </a>
              </div>
            </div>
          </div>
        </Col>
      </Row>

      <Row>
        <Col xs={24} lg={12}>
          <div style={{ paddingTop: 0 }}>
            {/* <Typography.Title>Mám záujem</Typography.Title> */}

            {/* <ContactForm listing={listing} /> */}

            <div style={{ maxWidth: 800, margin: "0 auto", padding: "2rem" }}>
              <Title level={2} style={{ color: "#a08e50", fontWeight: "bold" }}>
                Mám záujem
              </Title>

              <ContactForm listing={listing} />

              {/* <Form
                layout="vertical"
                form={form}
                onFinish={onFinish}
                autoComplete="off"
              >
                <Row gutter={16}>
                  <Col xs={24} md={12}>
                    <Form.Item label="Meno" name="firstName">
                      <Input />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12}>
                    <Form.Item label="Priezvisko" name="lastName">
                      <Input />
                    </Form.Item>
                  </Col>

                  <Col xs={24} md={12}>
                    <Form.Item label="Email" name="email">
                      <Input type="email" />
                    </Form.Item>
                  </Col>
                  <Col xs={24} md={12}>
                    <Form.Item label="Telefónne číslo" name="phone">
                      <Input />
                    </Form.Item>
                  </Col>

                  <Col span={24}>
                    <Form.Item
                      label="Otázka/poznámka (nepovinné)"
                      name="message"
                    >
                      <Input.TextArea rows={4} placeholder="Napíšte správu" />
                    </Form.Item>
                  </Col>

                  <Col span={24}>
                    <Form.Item>
                      <Button
                        type="primary"
                        htmlType="submit"
                        style={{
                          backgroundColor: "#a08e50",
                          borderColor: "#a08e50",
                          borderRadius: 6,
                          padding: "0 2rem",
                          height: "40px",
                        }}
                      >
                        Odoslať
                      </Button>
                    </Form.Item>
                  </Col>
                </Row>
              </Form> */}
            </div>
          </div>
        </Col>
      </Row>
    </React.Fragment>
  );

  // lazy image loading - big resolution only when needed
};

/*

<Col xs={24} md={0}>
<div
  style={{
    width: "100%",
  }}
>

  <Row gutter={[1, 1]}>
    {
      listing?.photos?.map((photo, index) => (
        <Col key={index} span={6}>
          <img
            src={
              listing.hasPreviews ? returnPreviewUrl(photo) : photo
            }
            alt={`Property ${index}`}
            style={{
              width: "100%",
              cursor: "pointer",
              borderRadius: "5px",
            }}
            onClick={() => handlePreview(photo)}
          />
        </Col>
      ))
    }
  </Row>
  <Modal
    visible={previewVisible}
    footer={null}
    onCancel={handleCancel}
  >
    <img
      alt="Preview"
      style={{ width: "100%", borderRadius: "3rem" }}
      src={previewImage}
    />
  </Modal>
</div>
</Col>

*/
